import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { InteractionEnum } from '../../../enum/interaction.enum';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { shipmentEditorPatchCustoms } from '../../../store/shipment-editor/shipment-editor.actions';
import { selectShipmentEditorShipment } from '../../../store/shipment-editor/shipment-editor.state';
import { ShipmentCommoditiesTableComponent } from '../shipment-commodities-table/shipment-commodities-table.component';
import { CustomsRelationshipEnum } from '../../../enum/customs-relationship.enum';
import { CustomsPayorEnum } from '../../../enum/customs-payor.enum';
import { CustomsPurposeEnum } from '../../../enum/customs-purpose.enum';
import { IncotermsEnum } from '../../../enum/incoterms.enum';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { Customs } from '../../../models/customs';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectRole } from '../../../store/profile/profile.state';
import { RoleEnum } from '../../../enum/role.enum';

@Component({
    selector: 'app-shipment-international',
    templateUrl: './shipment-international.component.html',
    styleUrls: ['./shipment-international.component.scss'],
    imports: [ ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, ShipmentCommoditiesTableComponent, MatCheckbox, MatInput ]
})
export class ShipmentInternationalComponent implements OnInit, OnDestroy {

    @Output()
    change: EventEmitter<InteractionEnum> = new EventEmitter<InteractionEnum>();

    private readonly destroy$ = new Subject<void>();

    formGroup: FormGroup;

    constructor(private store: Store<AppState>) {}

    public thirdPartyAllowed = toSignal(this.store.select(selectRole(RoleEnum.THIRD_PARTY_SHIPMENT)));
    public thirdPartyDuties = toSignal(this.store.select(selectShipmentEditorShipment).pipe(
        map(shipment => shipment.customs.dutiesPayor === CustomsPayorEnum.THIRD_PARTY),
        distinctUntilChanged()
    ));
    public commercialInvoiceActive = toSignal(this.store.select(selectShipmentEditorShipment).pipe(
        map(shipment => shipment.customs.commercialInvoice),
        distinctUntilChanged()
    ));

    ngOnInit(): void {
        this.formGroup = new FormGroup({
            termsOfSale: new FormControl(IncotermsEnum.EXW),
            purpose: new FormControl(CustomsPurposeEnum.SOLD),
            relationship: new FormControl(CustomsRelationshipEnum.NOT_RELATED),
            dutiesPayor: new FormControl(CustomsPayorEnum.NOT_DUTIABLE),
            dutiesAccount: new FormControl(''),
            commercialInvoice: new FormControl(false, { updateOn: 'change' }),
            commercialInvoiceFreight: new FormControl(''),
            commercialInvoiceInsurance: new FormControl(''),
            commercialInvoiceSurcharge: new FormControl(''),
            comments: new FormControl('')
        }, { updateOn: 'blur' });
        this.formGroup.valueChanges.pipe(
            distinctUntilChanged(),
            takeUntil(this.destroy$)
        ).subscribe(value => {
            const customs: Customs = {
                ...value,
                commercialInvoiceFreight: Math.round(parseFloat(value.commercialInvoiceFreight) * 100) / 100 || null,
                commercialInvoiceInsurance: Math.round(parseFloat(value.commercialInvoiceInsurance) * 100) / 100 || null,
                commercialInvoiceSurcharge: Math.round(parseFloat(value.commercialInvoiceSurcharge) * 100) / 100 || null
            };
            this.store.dispatch(shipmentEditorPatchCustoms({ customs }));
        });
        this.store.select(selectShipmentEditorShipment).pipe(
            map(shipment => shipment.customs),
            distinctUntilChanged(),
            takeUntil(this.destroy$)
        ).subscribe(customs => {
            const patch = {
                ...customs,
                commercialInvoiceFreight: customs.commercialInvoiceFreight ? customs.commercialInvoiceFreight.toFixed(2) : null,
                commercialInvoiceInsurance: customs.commercialInvoiceInsurance ? customs.commercialInvoiceInsurance.toFixed(2) : null,
                commercialInvoiceSurcharge: customs.commercialInvoiceSurcharge ? customs.commercialInvoiceSurcharge.toFixed(2) : null
            };
            this.formGroup.patchValue(patch, { emitEvent: false });
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    userChange(): void {
        this.change.emit(InteractionEnum.DEFAULT);
    }

}
